import { WorkOrderInfoDto } from '../../../../../api/api';
import { Section, SectionHeader } from '../../../../../styling/FormStyling';
import { formatTimeAndDateString } from '../../../../../utils/dateHandling';
import TextRow from '../../components/TextRow';
import { StyledSectionContent } from '../TaskDetailsStep';
import { StyledColumnFlex } from './Details';

interface Props {
  meterInformation: WorkOrderInfoDto;
  projectNumber?: string;
}
export const MeterDetails = (props: Props) => {
  const { meterInformation, projectNumber } = props;
  const info = meterInformation.workOrderInfo;

  return (
    <>
      <Section>
        <SectionHeader>Detaljer</SectionHeader>
        <StyledSectionContent>
          <StyledColumnFlex>
            <TextRow label="Målernummer" value={info?.meterId ?? ''} />
            <TextRow label="Målerrammens placering" value={info?.meterPlacement ?? ''} />
            <TextRow label="TaskManager nummer" value={info?.workOrderNumber ?? ''} />

            <TextRow label="Kundenavn" value={info?.customerName ?? ''} />
            <TextRow label="Installationsbenævnelse" value={info?.installationDescription ?? ''} />
            <TextRow label="Forbindelsespunkt beskrivelse" value={info?.connectionPointDescription ?? ''} />
            <br />
            <br />
            <StyledSectionContent>
              <StyledColumnFlex>
                <h4>Adgangsforhold</h4>
                <TextRow label="Kontaktperson" value={info?.accessInformation?.contactPerson ?? ''} />
                <TextRow label="Dørkode" value={info?.accessInformation?.doorCode ?? ''} />
                <TextRow label="Dørkode kommentar" value={info?.accessInformation?.doorCodeComment ?? ''} />
                <TextRow label="Nøglenummer" value={info?.accessInformation?.keyNumber ?? ''} />
                <TextRow label="Nøglekommentar" value={info?.accessInformation?.keyComment ?? ''} />
                <TextRow label="Nøgleplacering" value={info?.accessInformation?.keyPlacement ?? ''} />
                <TextRow label="Nøgle opbevaring" value={info?.accessInformation?.keyStorageLocation ?? ''} />
              </StyledColumnFlex>
            </StyledSectionContent>
            <TextRow label="Startdato" value={`${formatTimeAndDateString(info?.planningInfo?.taskStart ?? '')}  `} />
            <TextRow label="Slutdato" value={`${formatTimeAndDateString(info?.planningInfo?.taskEnd ?? '')} `} />
            <TextRow label="Planlagt til" value={`${formatTimeAndDateString(info?.planningInfo?.plannedArrival ?? '')}  `} />
            <TextRow label="Tid afsat" value={info?.planningInfo?.plannedDuration + ' minutter'} />
            <TextRow label="Beskrivelses type kode" value={info?.workDescriptionTypeCode ?? ''} />
            <TextRow label="Projektnummer" value={projectNumber ?? ''} />
            <TextRow label="Fakturerbar" value={info?.billable ? 'Ja' : 'Nej'} />
            <TextRow label="Forbindelsespunkt" value={info?.connectionPointId ?? ''} />
            <TextRow label="Målerrammenummer" value={info?.meterFrameId ?? ''} />
            <TextRow
              label="Planlagt tekniker"
              value={`${info?.planningInfo?.assignedTechnicianName} (${info?.planningInfo?.assignedTechnicianEmail})`}
            />
            <TextRow label="TaskManager ID" value={info?.workOrderId ?? ''} />
          </StyledColumnFlex>
        </StyledSectionContent>
      </Section>
    </>
  );
};
